"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Compositions_1 = __importDefault(require("../entity/FacetParts/Compositions"));
const defaultValue = [{ value: '16:9', count: 31 }];
exports.generateCompositionEntity = (jsons = defaultValue) => Compositions_1.default.fromJSON({
    buckets: jsons,
});
